import React, { useState } from "react";
import { format } from "date-fns";
import "./Mytable.css";
import { color } from "framer-motion";

function Mytable(prop) {
  // console.log(prop);

  const [Oldmit, setOldmiti] = useState(prop.miti != null ? prop.miti : []);

  // console.log(Oldmit);

  return (
    <>
      {Oldmit.length === 0 ? (
        <p style={{ textAlign: "center", color: "red" }}>
          {" "}
          No old miti present
        </p>
      ) : (
        <div className="div-vali-table">
          <div className="div-vali-table-head">
            <div className="kk">Sr.no</div>
            <div className="kk">Miti book Date</div>
            <div className="kk22">Type</div>
            <div className="kk"> total amount</div>
          </div>
          <div className="bosss">
            {Oldmit.map((e, i) => {
              return (
                <div className="div-vali-table-body" key={i + 3}>
                  <div className="kk">{i + 1}</div>
                  <div className="kk"> {e.created_at.split(" ")[0]}</div>
                  <div className="kk2">
                    {`${
                      e.miti.regular?.type !== undefined
                        ? `regular:- days = ${e.miti.regular.days}, price = ${e.miti.regular.price}\n`
                        : ""
                    }${
                      e.miti.Special?.type !== undefined
                        ? `Special:- days = ${e.miti.Special.days}, price = ${e.miti.Special.price}\n`
                        : ""
                    }${
                      e.miti.Olian?.type !== undefined
                        ? `Olian:- days = ${e.miti.Olian.days}, price = ${e.miti.Olian.price}\n`
                        : ""
                    }${
                      e.miti.sponsor?.type !== undefined
                        ? `sponsor:- days = ${e.miti.sponsor.days}, price = ${e.miti.sponsor.price}\n`
                        : ""
                    }`}
                  </div>

                  <div className="kk"> {e.total_amount}</div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
}

export default Mytable;
